import { brandColors, palette } from '../../../../theme';
import { AUTH_MODAL_COLOR } from '../AuthModal/authModal.constants';

export const EMAIL_VERIFICATION_STEP = {
  EMAIL: 'email',
  OTP: 'otp',
} as const;

export type EmailVerificationStep =
  (typeof EMAIL_VERIFICATION_STEP)[keyof typeof EMAIL_VERIFICATION_STEP];

export const EMAIL_VERIFICATION_COPY = {
  emailTitle: 'Verify your email',
  emailSubtitle: "We'll send a 6-digit code to your email",
  emailLabel: 'Email address',
  emailPlaceholder: 'you@example.com',
  emailInvalid: 'Enter a valid email address',
  sendCode: 'Send OTP',
  otpTitle: 'Enter code',
  otpSubtitle: 'Enter the 6-digit code we sent to your email',
  otpLabel: 'Enter OTP',
  change: 'Change',
  resend: 'Resend OTP',
  resendIn: (time: string) => `Resend OTP in ${time}`,
  verify: 'Verify & continue',
  sendFailed: "Couldn't send the code. Please try again.",
  wrongCode: "That code doesn't match. Please try again.",
  close: 'Close',
};

export const EMAIL_VERIFICATION_COLOR = {
  brand: AUTH_MODAL_COLOR.title,
  brandHover: brandColors.primary.yovoRed500,
  text: AUTH_MODAL_COLOR.text,
  muted: AUTH_MODAL_COLOR.muted,
  field: AUTH_MODAL_COLOR.field,
  fieldHover: brandColors.neutrals.grey300,
  disabled: AUTH_MODAL_COLOR.inactive,
  onBrand: AUTH_MODAL_COLOR.onInactive,
  error: palette.error.main,
  scrim: 'rgba(20, 16, 40, 0.45)',
  shadow: 'rgba(20, 16, 40, 0.25)',
};

export const EMAIL_VERIFICATION_METRICS = {
  radius: 20,
  buttonHeight: 48,
  buttonRadius: 12,
  otpBoxHeight: 52,
  otpGap: 10,
  otpRadius: 10,
  enterMs: 320,
  exitMs: 200,
  stepFadeMs: 280,
};

/** 30 → "0:30" */
export function formatCountdown(seconds: number) {
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
